export const KIBSI_REQUEST_ID_HEADER = 'x-kibsi-request-id';
//# sourceMappingURL=headers.js.map